 <template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Edit Product</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable
                 >Product Information</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2" editable
                 @click="firstStep" >Product Details</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3" editable
                 @click="secondStep" >Terpene Information</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 4" step="4" editable
                 @click="thirdStep" >Product Image</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Transcription/Registered Product Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="product.stepOne.name"
                          placeholder="Enter Transcription/Registered Product Name"
                          :rules="[(v) => !!v || 'Transcription/Registered Product Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Brand
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="manufacturers"
                          item-value="_id"
                          item-text="name"
                          label="Select Brand"
                          v-model="product.stepOne.brand"
                          :rules="[(v) => !!v || 'Brand is required!']"
                          required
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Cultivator
                        </label>
                        <v-select
                          :items="manufacturers"
                          item-value="_id"
                          item-text="name"
                          label="Select Cultivator"
                          v-model="product.stepOne.manufacturer"
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Profile</label>
                        <v-select
                          :items="profileTypes"
                          item-value="value"
                          item-text="name"
                          label="Select Profile"
                          v-model="product.stepOne.profileType"
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Irradiation</label>
                        <v-select
                          :items="irradiationTypes"
                          item-value="value"
                          item-text="name"
                          label="Select Irradiation"
                          v-model="product.stepOne.irradiation"
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          THC/CBD Ratio
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="cannabinoids"
                          item-value="value"
                          item-text="name"
                          label="Select THC/CBD Ratio"
                          v-model="product.stepOne.cannabinoid"
                          :rules="[(v) => !!v || 'THC/CBD Ratio is required!']"
                          required
                          solo
                        ></v-select>
                      </v-col>

                      <!-- <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Product Type
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="productTypes"
                          item-value="value"
                          item-text="name"
                          label="Select Product Type"
                          v-model="product.stepOne.productType"
                          :rules="[(v) => !!v || 'Product Type is required!']"
                          required
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Delivery Method
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="deliveryMethods"
                          item-value="value"
                          item-text="name"
                          label="Select Delivery Method"
                          v-model="product.stepOne.deliveryMethod"
                          :rules="[
                            (v) => !!v || 'Delivery Method is required!',
                          ]"
                          required
                          solo
                        ></v-select>
                      </v-col> -->

                      <!-- <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Api
                          <span class="red--text">*</span>
                        </label>
                        <v-textarea
                          v-model="product.stepOne.api"
                          placeholder="Enter API information"
                          :rules="[(v) => !!v || 'API is required!']"
                          required
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col> -->

                      <!-- <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          COA
                        </label>
                        <v-text-field
                          v-model="product.stepOne.coa"
                          :rules="validateCoaUrl"
                          placeholder="Enter COA"
                          solo
                        ></v-text-field>
                      </v-col> -->

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Formulation/Mode of Administration
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="apiOptions"
                          item-value="value"
                          item-text="name"
                          label="Select Formulation/Mode of Administration"
                          v-model="product.stepOne.modeOfAdministration"
                          :rules="[
                            (v) => !!v || 'Formulation/Mode of Administration is required!',
                          ]"
                          required
                          solo
                        ></v-select>
                        <!-- <v-textarea
                          v-model="product.stepOne.api"
                          placeholder="Enter Formulation/Mode of Administration Information"
                          :rules="[(v) => !!v || 'Formulation/Mode of Administration is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                          rows="3"
                        ></v-textarea> -->
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Availability
                          <span class="red--text">*</span>
                        </label>
                        <v-select
                          :items="stockList"
                          item-value="value"
                          item-text="name"
                          label="Availability"
                          v-model="product.stepOne.stockStatus"
                          :rules="[(v) => !!v || 'Availability is required!']"
                          required
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12">
                        <label class="form-control-label">
                          Cultivar/Strain
                        </label>
                        <v-text-field
                          v-model="product.stepOne.formulation"
                          placeholder="Enter Cultivar/Strain"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          API
                          <span class="red--text">*</span>
                        </label>
                        <v-textarea
                          v-model="product.stepOne.api"
                          placeholder="Enter THC & CBD Values"
                          :rules="[(v) => !!v || 'API is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">
                          Total terpenes content
                        </label>
                        <v-textarea
                          v-model="product.stepOne.terpenesContent"
                          placeholder="Enter Total terpenes content"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                       <v-col cols="12" sm="12">
                        <label class="form-control-label">
                          Additional Details
                        </label>
                        <v-textarea
                          v-model="product.stepOne.apiInformation"
                          placeholder="Enter Additional Details"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      

                        <!-- <v-col>
                        <label class="form-control-label">
                          Alternative Products
                        </label>
                      <v-combobox
                            v-model="selectedAlternativeProducts"
                            :items="alternativeProductsList"
                            item-text="name"
                            item-value="_id"
                            multiple
                            solo
                            small-chips
                            label="Select Alternative Products"
                            clearable
                            deletable-chips
                            hide-details
                            :loading="altProductsLoading"
                          >
                          </v-combobox>
                        </v-col> -->
                      <v-col cols="12">
                        <price
                          :priceObject="product.stepOne.retailPrice"
                          v-on:givePriceToParent="priceObj"
                        />
                      </v-col>

                      <!-- <v-col cols="12">
                        <Distributor
                          :distributorObject="product.stepOne.distributors"
                          v-on:giveDistributorToParent="distributorObj"
                        />
                      </v-col> -->

                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-0 pl-0">
                          <h4>Full Spectrum</h4>
                          <v-switch
                            class="pl-4 pt-3 mt-0"
                            v-model="product.stepOne.fullSpectrum"
                            flat:label="Yes"
                            inset
                          ></v-switch>
                        </v-card-title>
                      </v-col>
                      
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-0 pl-0">
                          <h4>Visible to Doctor?</h4>
                          <v-switch
                            class="pl-4 pt-3 mt-0"
                            v-model="product.stepOne.isDoctor"
                            flat:label="Yes"
                            inset
                          ></v-switch>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-0 pl-0">
                          <h4>Visible to Patient?</h4>
                          <v-switch
                            class="pl-4 pt-3 mt-0"
                            v-model="product.stepOne.isPatient"
                            flat:label="Yes"
                            inset
                          ></v-switch>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-0 pl-0">
                          <h4>Published</h4>
                          <v-switch
                            class="pl-4 pt-3 mt-0"
                            v-model="status"
                            flat:label="Yes"
                            inset
                          ></v-switch>
                        </v-card-title>
                      </v-col>
                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="cancel"
                          >Cancel</v-btn
                        >
                        <v-btn
                          :disabled="!valid || nextBtnDisabled"
                          color="#344452"
                          class="white--text"
                          :loading="loading"
                          @click="firstStep"
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-form ref="form2" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Indications</label>
                        <v-textarea
                          v-model="product.stepTwo.indications"
                          placeholder="Enter Indications"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Dosage</label>
                        <v-textarea
                          v-model="product.stepTwo.dosage"
                          placeholder="Enter Dosage"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Contra-Indications</label
                        >
                        <v-text-field
                          v-model="product.stepTwo.contraIndications"
                          placeholder="Enter ContraIndications"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Interactions</label>
                        <v-text-field
                          v-model="product.stepTwo.interactions"
                          placeholder="Enter Interactions"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Cautions</label>
                        <v-textarea
                          v-model="product.stepTwo.cautions"
                          placeholder="Enter Cautions"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Side Effects</label>
                        <v-textarea
                          v-model="product.stepTwo.sideEffects"
                          placeholder="Enter Side Effects"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Allergy And CrossSensitivity</label
                        >
                        <v-text-field
                          v-model="product.stepTwo.allergyAndCrossSensitivity"
                          placeholder="Enter Allergy And CrossSensitivity"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Pregnancy</label>
                        <v-text-field
                          v-model="product.stepTwo.pregnancy"
                          placeholder="Enter Pregnancy"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label">Brest Feeding</label>
                        <v-text-field
                          v-model="product.stepTwo.brestFeeding"
                          placeholder="Enter Brest Feeding"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Hepatic Impairment</label
                        >
                        <v-text-field
                          v-model="product.stepTwo.hepaticImpairment"
                          placeholder="Enter Hepatic Impairment"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Renal Impairment</label
                        >
                        <v-textarea
                          v-model="product.stepTwo.renalImpairment"
                          placeholder="Enter Renal Impairment"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Monitoring Requirements</label
                        >
                        <v-textarea
                          v-model="product.stepTwo.monitoringRequirements"
                          placeholder="Enter Monitoring Requirements"
                          solo
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Strain/Cultivar</label
                        >
                        <v-text-field
                          v-model="product.stepTwo.strainCultivar"
                          placeholder="Enter Strain/Cultivar"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <label class="form-control-label"
                          >Youtube Video Link</label
                        >
                        <v-text-field
                          v-model="product.stepTwo.videoUrl"
                          placeholder="Product video url"
                          :rules="validateUrl"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-2 white--text"
                          @click="back"
                          >Back</v-btn
                        >
                        <v-btn
                          :disabled="!valid"
                          class="ml-2 white--text"
                          color="#344452"
                          :loading="loading"
                          @click="secondStep"
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="v-form-body" step="3">
                  <v-form ref="form3" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                        <label class="form-control-label">
                          Unit
                        </label>
                        <v-text-field
                          type="number"
                          min="0"
                          v-model="product.stepThree.unit"
                          placeholder="Enter Unit"
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="8" xl="8">
                        <label class="form-control-label">
                          Description
                        </label>
                        <v-textarea
                          v-model="product.stepThree.methodReference"
                          placeholder="Enter Description"
                          solo
                          rows="2"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <hr class="ma-0">
                    <v-row>
                      <v-col cols="6">
                        <v-simple-table class="terpheninfo-table" >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  Name
                                </th>
                                <th class="text-left">
                                  Value
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(parameter, index) in parameters" :key="index">
                                <template v-if="product.stepThree.parameters[index] && index < middleIndex">
                                <td>{{ parameter.name }}</td>
                                <td> 
                                  <v-text-field
                                    type="number"
                                    min="0"
                                    v-model="product.stepThree.parameters[index].result"
                                    placeholder="Enter Result"
                                    solo
                                    @blur="setTwoDigitNumber($event.target.value,index)"
                                    hide-details
                                    class="py-2"
                                  >
                                  </v-text-field>
                                </td>
                                </template>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                       <v-col cols="6">
                        <v-simple-table class="terpheninfo-table" >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  Name
                                </th>
                                <th class="text-left">
                                  Value
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(parameter, index) in parameters" :key="index">
                                <template v-if="product.stepThree.parameters[index] && index >= middleIndex">
                                <td>{{ parameter.name }}</td>
                                <td> 
                                  <v-text-field
                                    type="number"
                                    min="0"
                                    v-model="product.stepThree.parameters[index].result"
                                    placeholder="Enter Result"
                                    solo
                                    @blur="setTwoDigitNumber($event.target.value,index)"
                                    hide-details
                                    class="py-2"
                                  >
                                  </v-text-field>
                                </td>
                                </template>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>    
                    <v-col class="text-right" cols="12">
                      <v-btn
                        color="#989898"
                        class="mr-2 white--text"
                        @click="back"
                        >Back</v-btn
                      >
                      <v-btn
                        :disabled="!valid"
                        class="ml-2 white--text"
                        color="#344452"
                        :loading="loading"
                        @click="thirdStep"
                        >Next</v-btn
                      >
                    </v-col>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="v-form-body" step="4">
                  <v-row>
                    <v-col
                      :class="$vuetify.breakpoint.mdAndUp ? 'col-4' : 'col-12'"
                      class="pa-5"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true">
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">
                                Drag and drop here to upload
                              </h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <document-upload
                      :documents="documents"
                      moduleName="product"
                      :moduleId="$route.params.id"
                      v-if="e1 == 4"
                    ></document-upload>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn
                      color="#989898"
                      class="mr-4 white--text"
                      @click="cancel"
                      >Cancel</v-btn
                    >
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                      >Save</v-btn
                    >
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { ProductService, MediaService } from "@/services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Price from "./Price";
// import {THUMBNAIL_WIDTH,THUMBNAIL_HEIGHT} from "@/constants";
import { ImageValidateMixin } from "@/mixins";
import Distributor from "./Distributor.vue";

export default {
  name: "AddProduct",
  components: {
    CommonSection,
    Price,
    Distributor,
    Treeselect,
    vueDropzone: vue2Dropzone,
    documentUpload: () => import("@/components/DocumentUpload"),
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      altProductsLoading: false,
      alternativeProductsList: [],
      selectedAlternativeProducts:[],
      e1: 1,
      open: ["public"],
      valid: true,
      loading: false,
      categories: [],
      manufacturers: [],
      parameters: [],
      parametersList: [],
      media: [],
      status: false,
      options: {
        page: 1,
        itemsPerPage: 100,
      },
      stockList: [
        {
          name: "In Stock",
          value: "In Stock",
        },
        {
          name: "Out of Stock",
          value: "Out of Stock",
        },
        {
          name: "Coming Soon",
          value: "Coming Soon",
        },
        {
          name: "Available in 1 week",
          value: "Available in 1 week",
        },
        {
          name: "Available in 2 weeks",
          value: "Available in 2 weeks",
        },
        {
          name: "Available in 3 weeks",
          value: "Available in 3 weeks",
        },
        {
          name: "Available in 4 weeks",
          value: "Available in 4 weeks",
        },
        {
          name: "Low Stock",
          value: "Low Stock",
        },
        {
          name: "To be discontinued",
          value: "To be discontinued",
        },
        {
          name: "Discontinued",
          value: "Discontinued",
        }
      ],
      irradiationTypes: [
        {
          name: "Non-Irradiated",
          value: "Non-Irradiated",
        },
        {
          name: "Gamma Irradiated",
          value: "Gamma Irradiated",
        },
        {
          name: "E-Beam Irradiated",
          value: "E-Beam Irradiated",
        },
        {
          name: "N/A",
          value: "N/A",
        },
        {
          name: "Other",
          value: "Other",
        }
      ],
      profileTypes: [
        {
          name: "Indica",
          value: "Indica",
        },
        {
          name: "Indica dominant hybrid",
          value: "Indica dominant hybrid",
        },
        {
          name: "Sativa",
          value: "Sativa",
        },
        {
          name: "Sativa dominant hybrid",
          value: "Sativa dominant hybrid",
        },
        {
          name: "Hybrid",
          value: "Hybrid",
        },
        {
          name: "Isolates",
          value: "Isolates",
        },
        {
          name: "N/A",
          value: "N/A",
        },
      ],
      cannabinoids: [
        {
          name: "Balanced Ratio",
          value: "Balanced Ratio",
        },
        {
          name: "CBD Rich",
          value: "CBD Rich",
        },
        {
          name: "THC Rich",
          value: "THC Rich",
        },
        {
          name: "Higher THC balanced",
          value: "Higher THC balanced",
        },
        {
          name: "Higher CBD balanced",
          value: "Higher CBD balanced",
        },
        {
          name: "Low THC",
          value: "Low THC",
        }
      ],
      productTypes: [
        {
          name: "Flowers",
          value: "Flowers",
        },
        {
          name: "Oil Spray",
          value: "Oil Spray",
        },
        {
          name: "Oil",
          value: "Oil",
        },
        {
          name: "Tablets/Capsules",
          value: "Tablets/Capsules",
        },
      ],
      deliveryMethods: [
        {
          name: "Inhaled via vaporiser",
          value: "Inhaled via vaporiser",
        },
        {
          name: "Oral",
          value: "Oral",
        },
        {
          name: "Oral Sublingual",
          value: "Oral Sublingual",
        },
      ],
      apiOptions: [
        {
          name: "Sublingual oil",
          value: "Sublingual oil",
        },
        {
          name: "Sublingual/oral pastilles",
          value: "Sublingual/oral pastilles",
        },
        {
          name: "Sublingual/oral lozenges",
          value: "Sublingual/oral lozenges",
        },
        {
          name: "Flower for vaporisation",
          value: "Flower for vaporisation"
        },
        {
          name: "Oil in prefilled vape cartridge",
          value: "Oil in prefilled vape cartridge"
        },
        {
          name: "Loose extracts for vaporisation",
          value: "Loose extracts for vaporisation"
        },
        {
          name: "Sublingual/buccal spray",
          value: "Sublingual/buccal spray"
        },
        {
          name: "Suppository (PR)",
          value: "Suppository (PR)"
        },
        {
          name: "Vaginal pessary/Suppository (PV)",
          value: "Vaginal pessary/Suppository (PV)"
        },
        {
          name: "Transdermal patch",
          value: "Transdermal patch"
        },
        {
          name: "Topical cream",
          value: "Topical cream"
        },
        {
          name: "Sublingual strip",
          value: "Sublingual strip"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      productId: null,
      product: {
        stepOne: {
          name: null,
          manufacturer: null,
          brand: null,
          modeOfAdministration: null,
          formulation: null,
          terpenesContent: null,
          profileType: null,
          irradiation: null,
          cannabinoid: null,
          productType: null,
          api: null,
          apiInformation: null,
          deliveryMethod: null,
          stockStatus: null,
          // coa: null,
          retailPrice: [],
          distributors: [],
          isDoctor:true,
          isPatient:true,
          fullSpectrum:false,
          alternativeProducts :[]

        },
        stepTwo: {
          indications: null,
          dosage: null,
          contraIndications: null,
          cautions: null,
          interactions: null,
          sideEffects: null,
          allergyAndCrossSensitivity: null,
          pregnancy: null,
          brestFeeding: null,
          hepaticImpairment: null,
          renalImpairment: null,
          monitoringRequirements: null,
          strainCultivar: null,
          videoUrl: null,
          status: null,
        },
        stepThree: {
          unit:"",
          methodReference:"",
          parameters: [],
        },
      },
      validateCoaUrl: [
        (v) =>
          !v ||
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
            v
          ) ||
          "Your url link is not valid.",
      ],
      validateUrl: [
        (v) =>
          !v ||
          /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(
            v
          ) ||
          "Your url link is not valid.",
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        thumbnailWidth: 400,
        maxFilesize: 2,
        maxFiles: 1,
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        acceptedFiles: "image/*",
        init() {
            this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
           });
           this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
       },
        // init() {
        //   this.on("thumbnail",(file) => {
        //     self.validateThumbnailDimension(file,THUMBNAIL_WIDTH,THUMBNAIL_HEIGHT)
        //   });
        // },
        // accept(file, done) {
        //   self.showError(file,THUMBNAIL_WIDTH,THUMBNAIL_HEIGHT,done)
        // }
      },
      middleIndex:0,
      nextBtnDisabled:false
    };
  },
  computed: {
    documents() {
      return this.media.filter((media) => media.mediaType == "doc");
    },
  },
  watch: {
    selectedAlternativeProducts(){      
      this.product.stepOne.alternativeProducts = this.selectedAlternativeProducts.map((item)=>item._id)
    }
  },
  methods: {
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "product");
      formData.append("mediaSubType", "file");
      formData.append("moduleId", this.$route.params.id);
    },
    aftercomplete(file, response) {
      this.$store.dispatch(
        "user/setSnack",
        "Product image uploaded successfully!"
      );
      this.$store.dispatch("user/setType", "info");
      this.productListData();
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB Image size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "product",
                moduleId: this.$route.params.id,
              },
            });
            this.productListData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Product image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$router.push("/products");
    },
    back() {
      this.e1 = this.e1 - 1;
    },
    normalizer(node) {
      return {
        id: node._id,
        label: node.name,
        children: node.childs,
      };
    },
    priceObj(value) {
      this.product.stepOne.retailPrice = value;
    },
    distributorObj(value) {
      this.product.stepOne.distributors = value;
    },
    setProduct(productData) {
      this.product.stepOne.name = productData.name;
      this.product.stepOne.manufacturer = productData.manufacturer;
      this.product.stepOne.brand = productData.brand;
      this.product.stepOne.modeOfAdministration = productData.modeOfAdministration;
      this.product.stepOne.formulation = productData.formulation;
      this.product.stepOne.terpenesContent = productData.terpenesContent;
      this.product.stepOne.profileType = productData.profileType;
      this.product.stepOne.irradiation = productData.irradiation;
      this.product.stepOne.cannabinoid = productData.cannabinoid;
      this.product.stepOne.productType = productData.productType;
      this.product.stepOne.api = productData.api;
      this.product.stepOne.apiInformation = productData.apiInformation;
      this.product.stepOne.deliveryMethod = productData.deliveryMethod;
      this.product.stepOne.retailPrice = productData.retailPrice;
      this.product.stepOne.distributors = productData.distributors;
      this.product.stepOne.stockStatus = productData.stockStatus;
      // this.product.stepOne.coa = productData.coa;
      this.product.stepOne.isDoctor = productData.isDoctor;
      this.product.stepOne.isPatient = productData.isPatient;
      this.product.stepOne.fullSpectrum = productData.fullSpectrum;
      this.selectedAlternativeProducts = productData.alternativeProducts;
      this.product.stepTwo.indications = productData.indications;
      this.product.stepTwo.dosage = productData.dosage;
      this.product.stepTwo.contraIndications = productData.contraIndications;
      this.product.stepTwo.cautions = productData.cautions;
      this.product.stepTwo.interactions = productData.interactions;
      this.status = productData.status === 1 ? true : false;
      this.product.stepTwo.sideEffects = productData.sideEffects;
      this.product.stepTwo.allergyAndCrossSensitivity =
        productData.allergyAndCrossSensitivity;
      this.product.stepTwo.pregnancy = productData.pregnancy;
      this.product.stepTwo.videoUrl = productData.videoUrl;
      this.product.stepTwo.brestFeeding = productData.brestFeeding;
      this.product.stepTwo.hepaticImpairment = productData.hepaticImpairment;
      this.product.stepTwo.renalImpairment = productData.renalImpairment;
      this.product.stepTwo.monitoringRequirements =
        productData.monitoringRequirements;
      this.product.stepTwo.strainCultivar = productData.strainCultivar;
      this.setStepThreeParametersData(productData.parameters)
      this.product.stepThree.unit = productData.unit;
      this.product.stepThree.methodReference = productData.methodReference;
    },
    setStepThreeParametersData(parametersData){
      let thirdStepParamsArray = [];
      this.parameters.forEach(paramData => {
        if(!paramData) return;
        let findObj = parametersData.find(param => param.parameterId === paramData._id);
        if(findObj){
          thirdStepParamsArray.push(findObj)
        }
        else{
          let newParam = {
            parameterId:paramData._id,
            name:paramData.name
          }
          thirdStepParamsArray.push(newParam)
        }
      });
      this.product.stepThree.parameters = thirdStepParamsArray;
    },
    async firstStep() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.product.stepOne.status = this.status ? 1 : 3;
        try {
          const response = await ProductService.update({
            id: this.$route.params.id,
            object: this.product.stepOne,
          });
          if (response) {
            this.e1 = 2;
            this.$store.dispatch("user/setSnack", "Product Updated.");
            this.$store.dispatch("user/setType", "info");
            this.loading = false;
          } else {
            this.loading = false;
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async secondStep() {
      if (this.$refs.form2.validate()) {
        this.loading = true;
        this.product.stepTwo.status = this.status ? 1 : 3;
        try {
          const response = await ProductService.update({
            id: this.$route.params.id,
            object: this.product.stepTwo,
          });
          if (response) {
            this.e1 = 3;
            this.$store.dispatch("user/setSnack", "Product Updated.");
            this.$store.dispatch("user/setType", "info");
            this.loading = false;
          } else {
            this.loading = false;
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async thirdStep() {
      if (this.$refs.form3.validate()) {
        this.loading = true;
        this.product.stepThree.status = this.status ? 1 : 3;
        try {
          if (this.$route.params.id) {
            const response = await ProductService.update({
              id: this.$route.params.id,
              object: this.product.stepThree,
            });
            if (response) {
              this.e1 = 4;
              this.$store.dispatch("user/setSnack", "Product Updated.");
              this.$store.dispatch("user/setType", "info");
              this.loading = false;
            } else {
              this.loading = false;
            }
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/products");
          this.$store.dispatch("user/setSnack", "Product added successfully!");
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async initialize() {
      this.nextBtnDisabled = true
      // Get Manufacturer
      const manufacturerList = await ProductService.getManufacturerList();
      this.manufacturers = manufacturerList.data.data;

      // Get Parameters
      const params = {
        limit: parseInt(this.options.itemsPerPage),
        skip:
          parseInt(this.options.page) * parseInt(this.options.itemsPerPage) -
          parseInt(this.options.itemsPerPage),
      };
      const parameterList = await ProductService.getParameterList(params);
      this.parameters = parameterList.data.data;
      this.middleIndex = Math.ceil(this.parameters.length / 2);

      this.arrangeParametersArray()

      await this.productListData();
      await this.getAlternativeProductsList();
      await this.uploadedImage();
      console.log("this.product.stepOne.alternativeProducts")
      this.nextBtnDisabled = false
    },
    async getAlternativeProductsList() {
      this.altProductsLoading = true;
      const params = {
        status:1,
      };
      const alternativeProductsList = await ProductService.productNameList(params);
      this.alternativeProductsList = alternativeProductsList.data.data.filter((product)=>product._id!==this.$route.params.id);
      this.altProductsLoading = false;
    },
    async productListData() {
      // Get Product Data
      const productDetails = await ProductService.get(this.$route.params.id);
      this.media = productDetails.data.data[0].media;
      this.setProduct(productDetails.data.data[0]);
    },
    arrangeParametersArray(){
      var foundIndex = this.parameters.findIndex(x => x.name == "Other");
      if(foundIndex){
        const otherParams = this.parameters[foundIndex];
        this.parameters.splice(foundIndex, 1);
        this.parameters.push(otherParams);
      }
    },
    setTwoDigitNumber(value,index){
      if(value!=""){
        const resultValue = parseFloat(value);
        if(!isNaN(resultValue)){
          this.product.stepThree.parameters[index].result = resultValue.toFixed(2);
        }
      }
    }
  },
  created() {
    this.initialize();
  },
};
</script>
<style>
.terpheninfo-table{
  border: thin solid rgba(0, 0, 0, 0.12);
}
tbody tr:nth-of-type(even){
  background-color: #FFFF !important;
}
</style>
